













import Vue from "vue";
import { AmoNotification } from "@/requests/mainApi/models/AmoNotification";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import { mapActions } from "vuex";
import { replaceURLs } from "@/utils/helpers/helpFunctions";

interface Data {}

interface Methods {
  readNotificationById: () => void;
  readNotifications: (params: { ids: number[] }) => void;
  getNotificationTypeTitle: (notificationType: string) => string;
}

interface Computed {
  notificationBody: string | null;
}

interface Props {
  notification: AmoNotification | null;
  isListItem: boolean;
  observer: IntersectionObserver | null;
}

export default Vue.extend({
  name: "Notification",
  props: {
    notification: null,
    isListItem: {
      type: Boolean,
      default: false,
    },
    observer: {
      type: IntersectionObserver,
      default: null,
    },
  },
  mounted() {
    setTimeout(() => {
      this.observer?.observe(this.$el);
    }, 0);
  },
  computed: {
    notificationBody() {
      if (!this.$props.notification) {
        return null;
      }

      return replaceURLs(this.$props.notification.body);
    },
  },
  methods: {
    readNotificationById() {
      const props = this as unknown as Props;
      this.readNotifications({ ids: [props.notification.id] });
    },
    ...mapActions(["readNotifications"]),
    getNotificationTypeTitle(notificationType) {
      return this.$t('app.profile.notifications.types.' + notificationType) || null;
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
